import React, { useEffect, useState, useRef, useContext } from "react";
import { store } from '../context/store';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

import { LICENCE_KEY } from "../constants/charts";

am4core.addLicense(LICENCE_KEY);

export default function AmChartBubble({
  chartId,
  chartData,
  categoryKey,
  valueKey,
  yValueKey,
  xValueKey,
  width,
  height
}) {
  const chart = useRef(null);
  const globalState = useContext(store);

  useEffect(() => {
    if (chartData && chartData.length > 0) {
      console.log("Chart data:", chartData);  // Debug the chart data
      loadChart();
    }
  }, [chartData, valueKey]);

  const loadChart = () => {
    // Create chart instance
    let x = am4core.create(chartId, am4charts.XYChart);
    x.data = chartData;  // Ensure chart data is passed correctly

    // Set up X and Y axes
    var xAxis = x.xAxes.push(new am4charts.ValueAxis());
    xAxis.renderer.minGridDistance = 50;
     xAxis.title.text = "Hours Occupied";

    var yAxis = x.yAxes.push(new am4charts.ValueAxis());
    yAxis.renderer.minGridDistance = 50;
    yAxis.title.text = "Utilisation %";

    // Create scatter series for bubble chart
    var series = x.series.push(new am4charts.XYSeries());
    series.dataFields.valueY = yValueKey;
    series.dataFields.valueX = xValueKey;
    series.dataFields.value = valueKey;  // This will control the size of the bubble


    // Create bullets (bubbles)
    var bullet = series.bullets.push(new am4charts.CircleBullet());
		bullet.circle.strokeOpacity = 1;  // Stroke opacity (1 for full opacity)
		bullet.circle.stroke = am4core.color("'0099ff");  // Stroke color
		bullet.circle.strokeWidth = 0;  // Stroke width
		bullet.circle.fillOpacity = 0.5;  // Fill opacity
		bullet.circle.fill = am4core.color("#0099ff");  // Fill color (change to your desired color)
		bullet.circle.nonScalingStroke = true;
		bullet.tooltipText = "{workplaceCode}: Hours Occupied:{valueX} Utilisation:{valueY}% Capacity:{value}";
	

    // Dynamically size the bubble based on the 'capacity' value
    series.heatRules.push({
      target: bullet.circle,
      property: "radius",
      min: 10,
      max: 60,
      dataField: "value"  // This should correspond to 'capacity'
    });

    // Add scrollbars
    x.scrollbarX = new am4core.Scrollbar();
    x.scrollbarY = new am4core.Scrollbar();

    // Add legend
    //x.legend = new am4charts.Legend();

    // Store reference for cleanup
    chart.current = x;

    return () => {
      x.dispose();
    };
  };

  return (
    <div id={chartId} style={{ width: width, height: height }}></div>
  );
}
